import React from 'react'

const Pencil = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M16 6.5l5.9 5.9-14 14L0 28.3l1.9-7.9C1.9 20.5 16 6.5 16 6.5zm11.1-5.3c1.6 1.6 1.6 4.3 0 5.9l-3 3-5.9-5.9 3-3c1.6-1.6 4.3-1.6 5.9 0z" />
  </svg>
)

export default Pencil
